import React from "react";
import { CheckCircle, Error, HourglassEmpty, HourglassFull, PlayArrow, Delete, Replay, HelpOutline } from "@mui/icons-material";
import { Tooltip, Box } from "@mui/material";


const StatusIcon = ({ status }) => {
    const getIcon = () => {
        switch (status) {
            case "Succeeded":
                return <CheckCircle color="success" />;
            case "Failed":
                return <Error color="error" />;
            case "Processing":
                return <PlayArrow color="primary" />;
            case "Enqueued":
                return <HourglassEmpty color="warning" />;
            case "Scheduled":
                return <HourglassFull color="warning" />;
            case "AwaitingRetry":
                return <Replay color="warning" />;
            case "Deleted":
                return <Delete color="disabled" />;
            case "NotFound":
            default:
                return <HelpOutline color="action" />;
        }
    };

    const getTooltipTitle = () => {
        switch (status) {
            case "Succeeded":
                return "Job succeeded";
            case "Failed":
                return "Job failed";
            case "Processing":
                return "Job is processing";
            case "Enqueued":
                return "Job is enqueued";
            case "Scheduled":
                return "Job is scheduled";
            case "AwaitingRetry":
                return "Job is awaiting retry";
            case "Deleted":
                return "Job was deleted";
            case "NotFound":
            default:
                return "Job status not found";
        }
    };

    return (
        <Tooltip title={getTooltipTitle()} arrow>
            <Box>{getIcon()}</Box>
        </Tooltip>
    );
};

export default StatusIcon;
